import 'babel-polyfill';
import '../common/polyfills/forEachPolyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import createStore from './store/createStore';
// import { words, capitalize, flow } from 'lodash';

const MOUNT_NODE_ID = 'app';
const MOUNT_NODE = document.getElementById(MOUNT_NODE_ID);
const store = createStore(window.__INITIAL_STATE__);

let render = () => {
  const App = require('./containers/App/index').default;
  ReactDOM.render(<App store={store} />, MOUNT_NODE);
};

const renderReactInputControls = () => {
  document.querySelectorAll('[data-react-input-control]').forEach(element => {
    const InputControl = require('./containers/InputControls/index').default;
    // const props = {};
    // for (let attrName in element.attributes) {
    //   if (element.attributes.hasOwnProperty(attrName)) {
    //     const attr = element.attributes[attrName];
    //     props[attr.name] = attr.value;
    //   }
    // }
    ReactDOM.render(<InputControl {...element.dataset} />, element);
  });
};

// Development Tools
// ------------------------------------
if (window.__DEV__) {
  if (module.hot) {
    const renderApp = render;
    const renderError = error => {
      const RedBox = require('redbox-react').default;

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE);
    };

    render = () => {
      try {
        renderApp();
        renderReactInputControls();
      } catch (e) {
        console.error(e);
        renderError(e);
      }
    };

    // Setup hot module replacement
    module.hot.accept(['./components', './containers'], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE);
        render();
      }),
    );
  }
}

// Let's Go!
// ------------------------------------
if (!window.__TEST__) {
  render();
  renderReactInputControls();
}

// Dynamic Components



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/index.js